export const agreementsRouter = [
  {
    path: "study-collection-agreement",
    name: "study-collection-agreement",
    component: () => import("@/views/study-agreement/collection-agreement.vue"),
    meta: {
      title: "个人信息收集清单"
    }
  },
  {
    path: "study-agreement-about",
    name: "study-agreement-about",
    component: () => import("@/views/study-agreement/about.vue"),
    meta: {
      title: "关于我们"
    }
  },
  {
    path: "study-privacy-agreement",
    name: "study-privacy-agreement",
    component: () => import("@/views/study-agreement/privacy-agreement.vue"),
    meta: {
      title: "隐私政策"
    }
  },
  {
    path: "study-cancellation-agreement",
    name: "study-cancellation-agreement",
    component: () => import("@/views/study-agreement/cancellation-agreement.vue"),
    meta: {
      title: "注销账号"
    }
  },
  {
    path: "study-termination-agreement",
    name: "study-termination-agreement",
    component: () => import("@/views/study-agreement/termination-agreement.vue"),
    meta: {
      title: "注销政策"
    }
  },
  {
    path: "study-children-agreement",
    name: "study-children-agreement",
    component: () => import("@/views/study-agreement/children-agreement.vue"),
    meta: {
      title: "儿童隐私保护政策"
    }
  },
  {
    path: "study-user-agreement",
    name: "study-user-agreement",
    component: () => import("@/views/study-agreement/user-agreement.vue"),
    meta: {
      title: "注册协议"
    }
  },
  {
    path: "study-triple-agreement",
    name: "study-triple-agreement",
    component: () => import("@/views/study-agreement/triple-agreement.vue"),
    meta: {
      title: "第三方信息共享清单"
    }
  },
  {
    path: "account-cancellation-notice",
    name: "account-cancellation-notice",
    component: () => import("@/views/account-cancellation-notice/index.vue"),
    meta: {
      title: "注销协议"
    }
  },
  // 激励规则 - 等级规则
  {
    path: "incentive-rules-level",
    name: "incentive-rules-level",
    component: () => import("@/views/incentive-rules/level.vue"),
    meta: {
      title: "等级规则"
    }
  },
  // 激励规则 - 小红花规则
  {
    path: "incentive-rules-little-red-flower",
    name: "incentive-rules-little-red-flower",
    component: () => import("@/views/incentive-rules/little-red-flower.vue"),
    meta: {
      title: "小红花规则"
    }
  },
  // 激励规则 - 抽奖流程规则
  {
    path: "incentive-rules-lottery-procedure",
    name: "incentive-rules-lottery-procedure",
    component: () => import("@/views/incentive-rules/lottery-procedure.vue"),
    meta: {
      title: "抽奖流程规则"
    }
  },
  // 激励规则 - 阳光值规则
  {
    path: "incentive-rules-sunshine-value",
    name: "incentive-rules-sunshine-value",
    component: () => import("@/views/incentive-rules/sunshine-value.vue"),
    meta: {
      title: "阳光值规则"
    }
  }
];
